import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE LEAGUEREGIONS
 */
function PlayerOffices() {
  return (
    <Crud
      title="Player Offices"
      getUrl={() => "/Player/Office_GetList"}
      // INSERT
      insertUrl={() => "/Player/Office_Insert"}
      insertParams={({ userId }, { officeName }) => ({
        OfficeName: officeName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/Office_Update"}
      updateParams={({ userId }, { idOffice, officeName }) => ({
        IdOffice: idOffice,
        OfficeName: officeName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/Office_Delete"}
      deleteParams={({ userId }, id) => ({
        IdOffice: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idOffice"
      >
        IdOffice
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="officeName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default PlayerOffices;
